import type { TOC } from '@ember/component/template-only';
import { PhUser } from 'ember-phosphor-icons';
interface AppHeaderInitialsIconSig {
  Args: {
    initials?: string;
    size?: 'sm' | 'md';
  };
  Element: HTMLDivElement;
}

const AppHeaderInitialsIconComponent: TOC<AppHeaderInitialsIconSig> = <template>
  <div
    class="employee-initials-icon tio-fg-inverse tio-bg-success
      {{if (eq @size 'sm') 'employee-initials-icon--sm' 'employee-initials-icon--md'}}"
    ...attributes
  >
    {{#if @initials}}
      {{@initials}}
    {{else}}
      <PhUser @size={{if (eq @size "sm") 16 24}} weight="fill" />
    {{/if}}
  </div>
</template>;

export default AppHeaderInitialsIconComponent;
